<template>
  <div class="settlement-stat">
    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon total">
              <i class="el-icon-s-finance"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.totalSettlements || 0 }}</div>
              <div class="stats-label">结算总数</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon pending">
              <i class="el-icon-time"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.pendingSettlements || 0 }}</div>
              <div class="stats-label">待结算</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon amount">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatAmount(statistics.totalAmount || 0) }}</div>
              <div class="stats-label">结算总额</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon settled">
              <i class="el-icon-success"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatAmount(statistics.settledAmount || 0) }}</div>
              <div class="stats-label">已结算金额</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">结算单号：</span>
            <el-input v-model="searchInfo.settlementNo" clearable placeholder="请输入结算单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">订单号：</span>
            <el-input v-model="searchInfo.orderNo" clearable placeholder="请输入订单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">结算状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">卖家ID：</span>
            <el-input v-model="searchInfo.sellerId" clearable placeholder="请输入卖家ID"></el-input>
          </div>
          <div class="search-item">
            <span class="label">支付宝账号：</span>
            <el-input v-model="searchInfo.sellerAlipayAccount" clearable placeholder="请输入支付宝账号"></el-input>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="createDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
          <div class="search-item date-picker">
            <span class="label">结算时间：</span>
            <el-date-picker v-model="settlementDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-refresh" @click="refreshStats">刷新统计</el-button>
      </div>
    </div>

    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="settlementNo" label="结算单号" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="结算状态" width="100">
          <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
              </el-tag>
          </template>
      </el-table-column>
        <el-table-column prop="sellerId" label="卖家ID" width="100"></el-table-column>
        <el-table-column prop="orderAmount" label="订单金额" width="120">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: 500;">¥{{ scope.row.orderAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="platformFee" label="平台抽成" width="120">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: 500;">¥{{ scope.row.platformFee }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="settlementAmount" label="结算金额" width="120">
          <template slot-scope="scope">
            <span style="color: #67C23A; font-weight: 500;">¥{{ scope.row.settlementAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sellerAlipayAccount" label="支付宝账号" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sellerAlipayName" label="支付宝实名" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="transferNo" label="单据号" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.transferNo || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementTime" label="结算时间" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.settlementTime || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 1"
              @click="showTransferDialog(scope.row)"
            >
              转账
            </el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 结算详情弹窗 -->
    <el-dialog
      title="结算详情"
      :visible.sync="detailVisible"
      width="900px"
      :before-close="handleClose"
      custom-class="settlement-detail-dialog">
      <div v-if="settlementDetail" class="settlement-detail-wrapper">
        <div class="settlement-detail">
          <!-- 基本信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">基本信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">结算单号</span>
                    <span class="item-value">{{ settlementDetail.settlementNo }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">结算状态</span>
                    <span class="item-value">
                      <el-tag :type="getStatusTagType(settlementDetail.status)" size="small">
                        {{ getStatusText(settlementDetail.status) }}
                      </el-tag>
                    </span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">创建时间</span>
                    <span class="item-value">{{ settlementDetail.createTime }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 订单信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">订单信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">订单ID</span>
                    <span class="item-value">{{ settlementDetail.orderId }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">订单号</span>
                    <span class="item-value">{{ settlementDetail.orderNo }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 16px;">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">卖家ID</span>
                    <span class="item-value">{{ settlementDetail.sellerId }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">订单金额</span>
                    <span class="item-value" style="color: #409EFF; font-weight: 500;">¥{{ settlementDetail.orderAmount }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 结算信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">结算信息</span>
            </div>
            <div class="card-body">
              <div class="price-info">
                <el-row :gutter="16">
                  <el-col :span="8">
                    <div class="price-item">
                      <div class="price-label">订单金额</div>
                      <div class="price-value">¥{{ settlementDetail.orderAmount }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="price-item">
                      <div class="price-label">平台抽成</div>
                      <div class="price-value" style="color: #E6A23C;">¥{{ settlementDetail.platformFee }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="price-item price-item-highlight">
                      <div class="price-label">结算金额</div>
                      <div class="price-value">¥{{ settlementDetail.settlementAmount }}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <!-- 支付宝信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">支付宝信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">支付宝账号</span>
                    <span class="item-value">{{ settlementDetail.sellerAlipayAccount }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">支付宝实名</span>
                    <span class="item-value">{{ settlementDetail.sellerAlipayName }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 转账信息卡片 -->
          <div class="detail-card" v-if="settlementDetail.status >= 2">
            <div class="card-header">
              <span class="card-title">转账信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">单据号</span>
                    <span class="item-value">{{ settlementDetail.transferNo || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="item-label">结算时间</span>
                    <span class="item-value">{{ settlementDetail.settlementTime || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 16px;" v-if="settlementDetail.status === 4">
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="item-label">失败原因</span>
                    <span class="item-value" style="color: #F56C6C;">{{ settlementDetail.failureReason || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 转账弹窗 -->
    <el-dialog
      title="进行转账"
      :visible.sync="transferDialogVisible"
      width="650px">
      <el-form :model="transferForm" :rules="transferRules" ref="transferForm" label-width="100px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="结算单号">
              <el-input v-model="transferForm.settlementNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付宝实名">
              <el-input v-model="transferForm.sellerAlipayName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="支付宝账号">
              <el-input v-model="transferForm.sellerAlipayAccount" disabled>
                <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(transferForm.sellerAlipayAccount, '支付宝账号')"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算金额">
              <el-input v-model="transferForm.settlementAmount" disabled>
                <template slot="prepend">¥</template>
                <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(transferForm.settlementAmount, '结算金额')"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="remark" disabled>
                <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(remark, '备注')"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付密码">
              <el-input v-model="payPassword" disabled>
                <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(payPassword, '支付密码')"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-form-item label="单据号" prop="transferNo" label-width="100px">
          <el-input v-model="transferForm.transferNo" placeholder="请输入支付宝单据号" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="transferDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTransfer" :loading="transferring">确定转账</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {axios} from "../../config/axios";

  export default {
    name: "seller-settlement-stat",
    data () {
      return {
        // 统计数据
        statistics: {
          totalSettlements: 0,
          pendingSettlements: 0,
          totalAmount: 0,
          settledAmount: 0
        },
        remark:'机二二手交易平台结算',
        payPassword:'Jier888_',
        // 表格数据
        total: 0,
        tableData: [],
        createDateArr: [],
        settlementDateArr: [],
        loading: false,
        currentPage: 1,
        transferring: false,
        // 弹窗控制
        detailVisible: false,
        transferDialogVisible: false,
        settlementDetail: null,
        currentSettlement: null,
        // 转账表单
        transferForm: {
          sellerSettlementId: null,
          settlementNo: '',
          settlementAmount: '',
          sellerAlipayAccount: '',
          sellerAlipayName: '',
          transferNo: ''
        },
        // 搜索条件
        searchInfo: {
          settlementNo: '',
          sellerId: '',
          orderId: '',
          orderNo: '',
          orderAmount: '',
          settlementAmount: '',
          sellerAlipayAccount: '',
          sellerAlipayName: '',
          status: '',
          transferNo: '',
          startDate: '',
          endDate: '',
          startSettlementTime: '',
          endSettlementTime: '',
          pageNumber: 1,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '待结算', value: 1 },
          { label: '结算中', value: 2 },
          { label: '已结算', value: 3 },
          { label: '结算失败', value: 4 }
        ],
        // 表单验证规则
        transferRules: {
          transferNo: [
            { required: true, message: '请输入支付宝单据号', trigger: 'blur' }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.settlementNo'(newVal){
        if (newVal === ""){
          this.getSettlementList();
        }
      },
      'searchInfo.orderNo'(newVal){
        if (newVal === ""){
          this.getSettlementList();
        }
      },
      'searchInfo.sellerId'(newVal){
        if (newVal === ""){
          this.getSettlementList();
        }
      },
      'searchInfo.sellerAlipayAccount'(newVal){
        if (newVal === ""){
          this.getSettlementList();
        }
      },
      'createDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getSettlementList();
        }
      },
      'settlementDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startSettlementTime = "";
          this.searchInfo.endSettlementTime = "";
          this.getSettlementList();
        }
      },
    },
    created() {
      this.getSettlementList();
      this.getStatistics();
    },
    methods: {
      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 1;
        this.getSettlementList();
      },

      // 刷新统计数据
      refreshStats() {
        this.getStatistics();
        this.getSettlementList();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val;
        this.getSettlementList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 1;
        this.getSettlementList();
      },

      // 获取结算列表
      getSettlementList() {
        if (this.createDateArr && this.createDateArr.length === 2) {
          this.searchInfo.startDate = this.createDateArr[0];
          this.searchInfo.endDate = this.createDateArr[1];
        }
        if (this.settlementDateArr && this.settlementDateArr.length === 2) {
          this.searchInfo.startSettlementTime = this.settlementDateArr[0];
          this.searchInfo.endSettlementTime = this.settlementDateArr[1];
        }

        if (this.loading) return;
        this.loading = true;

        axios.get('/sellerSettlement/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      // 获取统计数据
      getStatistics() {
        axios.get('/sellerSettlement/statistics').then(result => {
          if (result.code === 200) {
            this.statistics = {
              totalSettlements: result.data.totalSettlements || 0,
              pendingSettlements: result.data.pendingSettlements || 0,
              totalAmount: result.data.totalAmount || 0,
              settledAmount: result.data.settledAmount || 0
            };
          } else {
            this.$message.error(result.message || '获取统计数据失败');
          }
        }).catch(err => {
          console.error('获取统计数据失败:', err);
          this.$message.error('获取统计数据失败');
        });
      },

      // 查看结算详情
      viewDetail(row) {
        this.settlementDetail = row;
        this.detailVisible = true;
      },

      // 显示转账弹窗
      showTransferDialog(row) {
        this.currentSettlement = row;
        this.transferForm = {
          sellerSettlementId: row.id,
          settlementNo: row.settlementNo,
          settlementAmount: row.settlementAmount,
          sellerAlipayAccount: row.sellerAlipayAccount,
          sellerAlipayName: row.sellerAlipayName,
          transferNo: ''
        };
        this.transferDialogVisible = true;
      },

      // 提交转账
      submitTransfer() {
        this.$refs.transferForm.validate((valid) => {
          if (valid) {
            this.transferring = true;
            axios.get('/sellerSettlement/transfer', {
              params: {
                sellerSettlementId: this.transferForm.sellerSettlementId,
                transferNo: this.transferForm.transferNo
              }
            }).then(result => {
              this.transferring = false;
              if (result.code === 200) {
                this.$message.success('转账成功');
                this.transferDialogVisible = false;
                this.getSettlementList();
                this.getStatistics();
              } else {
                this.$message.error(result.message || '转账失败');
              }
            }).catch(err => {
              console.error(err);
              this.transferring = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.settlementDetail = null;
        done();
      },

      // 工具方法
      formatAmount(amount) {
        if (!amount) return '¥0';
        if (amount >= 10000) {
          return '¥' + (amount / 10000).toFixed(1) + '万';
        }
        return '¥' + amount.toLocaleString();
      },

      getStatusText(status) {
        const statusMap = {
          1: '待结算',
          2: '结算中',
          3: '已结算',
          4: '结算失败'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          1: 'warning',
          2: 'primary',
          3: 'success',
          4: 'danger'
        };
        return typeMap[status] || 'info';
      },

      // 复制到剪贴板
      copyToClipboard(text, label) {
        if (!text) {
          this.$message.warning(`${label}为空，无法复制`);
          return;
        }
        
        // 创建临时文本框
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        
        try {
          document.execCommand('copy');
          this.$message.success(`${label}已复制到剪贴板`);
        } catch (err) {
          this.$message.error('复制失败，请手动复制');
        }
        
        document.body.removeChild(textarea);
      }
    }
  }
</script>

<style lang="less" scoped>
  .settlement-stat {
    .stats-cards {
      margin-bottom: 20px;

      .el-col {
        min-width: 280px;
        margin-top: 30px;
      }

      .stats-card {
        background: #fff;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        min-width: 260px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
        }

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          margin-right: 16px;
          flex-shrink: 0;

          &.total {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
          &.pending {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }
          &.amount {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }
          &.settled {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }
        }

        .stats-content {
          flex: 1;
          min-width: 0;

          .stats-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            line-height: 1.2;
            word-break: break-all;
          }
          .stats-label {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 结算详情弹窗样式
  /deep/ .settlement-detail-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #e8eaec;
      padding: 20px 24px;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }

    .el-dialog__body {
      padding: 0;
      background: #f5f7fa;
    }
  }

  .settlement-detail-wrapper {
    padding: 20px;
  }

  .settlement-detail {
    // 卡片基础样式
    .detail-card {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      .card-header {
        padding: 16px 20px;
        background: linear-gradient(90deg, #f7f8fa 0%, #fff 100%);
        border-bottom: 1px solid #ebeef5;

        .card-title {
          font-size: 15px;
          font-weight: 600;
          color: #303133;
          position: relative;
          padding-left: 12px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background: #409EFF;
            border-radius: 2px;
          }
        }
      }

      .card-body {
        padding: 20px;
      }
    }

    // 详情项样式
    .detail-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0;

      .item-label {
        color: #909399;
        font-size: 14px;
        min-width: 100px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .item-value {
        color: #303133;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
      }
    }

    // 费用信息样式
    .price-info {
      .price-item {
        text-align: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        transition: all 0.3s;

        &:hover {
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
          border-color: #c6e2ff;
        }

        .price-label {
          font-size: 13px;
          color: #909399;
          margin-bottom: 8px;
        }

        .price-value {
          font-size: 20px;
          font-weight: 600;
          color: #303133;
        }

        &.price-item-highlight {
          background: linear-gradient(135deg, #fff6e6 0%, #ffecd0 100%);
          border-color: #ffd591;

          .price-value {
            color: #67C23A;
            font-size: 24px;
          }
        }
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  @media screen and (max-width: 992px) {
    .settlement-stat .stats-cards {
      .el-col {
        min-width: 45%;
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .settlement-stat .stats-cards {
      .el-col {
        margin-bottom: 16px;
        min-width: 100%;
      }

      .stats-card {
        min-width: auto;
      }
    }

    .settlement-detail-wrapper {
      padding: 12px;
    }

    .settlement-detail {
      .detail-card {
        .card-body {
          padding: 16px;
        }
      }

      .detail-item {
        flex-direction: column;
        align-items: flex-start;

        .item-label {
          margin-bottom: 4px;
        }
      }

      .price-info {
        .el-col {
          margin-bottom: 12px;
        }

        .price-item {
          padding: 12px;

          .price-value {
            font-size: 18px;
          }

          &.price-item-highlight .price-value {
            font-size: 20px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    .settlement-stat .stats-cards {
      .stats-card {
        padding: 16px;

        .stats-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
          margin-right: 12px;
        }

        .stats-content {
          .stats-number {
            font-size: 20px;
          }
          .stats-label {
            font-size: 12px;
          }
        }
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  /deep/ .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-table .warning-row {
    background: #fdf6ec;
  }

  /deep/ .el-table .success-row {
    background: #f0f9ff;
  }
</style>
